/* Localeazy — Apple Pro interactions */
(function () {
  if (window.__apInit) return; window.__apInit = true;
  var io = 'IntersectionObserver' in window;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.ap-rv, .ap-hero');
    if (!io) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var o = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); o.unobserve(e.target); } });
    }, { threshold: .15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { o.observe(e); });
  }

  function videos(root) {
    var vs = (root || document).querySelectorAll('video[data-ap-vid]');
    if (!io) return;
    var o = new IntersectionObserver(function (en) {
      en.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
    }, { threshold: .35 });
    vs.forEach(function (v) { v.muted = true; v.playsInline = true; o.observe(v); });
  }

  function statement(root) {
    (root || document).querySelectorAll('[data-ap-stmt]').forEach(function (p) {
      if (p.dataset.ready) return; p.dataset.ready = 1;
      var html = p.innerHTML.replace(/<em>(.*?)<\/em>/g, function (m, t) { return t.split(/\s+/).map(function (w) { return '\u0001' + w; }).join(' '); });
      var words = html.split(/\s+/);
      p.innerHTML = words.map(function (w) { return w.charAt(0) === '\u0001' ? '<span class="g">' + w.slice(1) + '</span>' : '<span>' + w + '</span>'; }).join(' ');
      var spans = p.querySelectorAll('span');
      function upd() {
        var r = p.getBoundingClientRect(), vh = window.innerHeight;
        var prog = Math.min(1, Math.max(0, (vh * .85 - r.top) / (r.height + vh * .35)));
        var n = Math.round(prog * spans.length);
        spans.forEach(function (s, i) { s.classList.toggle('is-lit', i < n); });
      }
      window.addEventListener('scroll', upd, { passive: true }); upd();
    });
  }

  function gallery(root) {
    (root || document).querySelectorAll('[data-ap-hl]').forEach(function (g) {
      var t = g.querySelector('.ap-hl__track'); if (!t) return;
      g.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var it = t.querySelector('.ap-hl__item'); var w = it ? it.getBoundingClientRect().width + 20 : 380;
          t.scrollBy({ left: w * (+b.dataset.dir), behavior: 'smooth' });
        });
      });
    });
  }

  function compare(root) {
    (root || document).querySelectorAll('[data-ap-cmp]').forEach(function (c) {
      var bs = c.querySelectorAll('.ap-seg button'), ps = c.querySelectorAll('.ap-cmp__panel');
      bs.forEach(function (b, i) {
        b.addEventListener('click', function () {
          bs.forEach(function (x, j) { x.classList.toggle('is-on', i === j); x.setAttribute('aria-selected', i === j); });
          ps.forEach(function (x, j) { x.classList.toggle('is-on', i === j); });
        });
      });
    });
  }

  function battery(root) {
    (root || document).querySelectorAll('[data-ap-bat]').forEach(function (w) {
      if (w.dataset.ready) return; w.dataset.ready = 1;
      var ring = w.querySelector('.ap-bat__ring'), fg = w.querySelector('.fg'), val = w.querySelector('[data-bat-val]'),
          lab = w.querySelector('[data-bat-lab]'), notif = w.querySelector('.ap-notif');
      var months = +w.dataset.months || 3, t0 = null, running = false, D = 9000;
      var labels = { use: w.dataset.lUse, low: w.dataset.lLow, charge: w.dataset.lCharge, full: w.dataset.lFull };
      function frame(ts) {
        if (!running) return;
        if (!t0) t0 = ts;
        var p = ((ts - t0) % (D + 3500)) / D, pct, state;
        if (p <= 1) { pct = Math.max(4, Math.round(100 - p * 96)); state = pct <= 15 ? 'low' : 'use'; }
        else { var q = Math.min(1, (p - 1) / .28); pct = Math.round(4 + q * 96); state = q < 1 ? 'charge' : 'full'; }
        fg.style.strokeDashoffset = 100 - pct;
        ring.classList.toggle('is-low', state === 'low');
        if (val) val.textContent = state === 'use' || state === 'low' ? (Math.max(0, (pct / 100) * months)).toFixed(1).replace('.', ',') + ' mois' : pct + ' %';
        if (lab) lab.textContent = labels[state] || '';
        if (notif) notif.classList.toggle('is-on', state === 'low' || state === 'charge');
        requestAnimationFrame(frame);
      }
      if (!io) { running = true; requestAnimationFrame(frame); return; }
      new IntersectionObserver(function (en) {
        en.forEach(function (e) { var was = running; running = e.isIntersecting; if (running && !was) { t0 = null; requestAnimationFrame(frame); } });
      }, { threshold: .3 }).observe(w);
    });
  }

  function header() {
    var b = document.querySelector('[data-aph-burger]'), m = document.querySelector('[data-aph-menu]');
    if (!b || !m || b.dataset.ready) return; b.dataset.ready = 1;
    b.addEventListener('click', function () {
      var open = !m.classList.contains('is-open');
      m.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
      b.querySelector('.o').style.display = open ? 'none' : ''; b.querySelector('.c').style.display = open ? '' : 'none';
    });
  }

  function init(root) { reveal(root); videos(root); statement(root); gallery(root); compare(root); battery(root); header(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
